import { useTheme, useMediaQuery } from '@mui/material';

const TABBREAKPOINT = "lg"

export function useIsLargeScreen() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up(TABBREAKPOINT));
}
